/* eslint-disable no-console */
/* eslint-disable no-param-reassign */

import {
  ProductState,
  ProductAction,
  ProductActionTypes,
  ProductData,
} from './types';

const INITIAL_STATE: ProductState = {
  products: [],
  search: [],
  product: {},
  productDetalails: {} as ProductData,
  response: {
    to: '0',
    total: '0',
    currentPage: 1,
    lastPage: 1,
  },
  error: false,
  loading: false,
  loadingSearch: false,
  loadingProduct: false,
  filters: {
    categoryId: '',
    priceMin: 0,
    priceMax: 100000,
    moreProducts: 18,
    order: 'desc',
    hasMore: false,
  },
};

export default function product(
  state = INITIAL_STATE,
  action: ProductAction,
): ProductState {
  switch (action.type) {
    case ProductActionTypes.RECHARGE:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ProductActionTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ProductActionTypes.LOAD_SUCCCES:
      return {
        ...state,
        products: action.payload.data,
        loading: false,
        error: false,
      };
    case ProductActionTypes.RESPONSE_SUCCCES:
      return {
        ...state,
        filters: {
          ...state.filters,
          hasMore: action.payload.data.currentPage < action.payload.data.lastPage,
        },
        response: action.payload.data,
      };
    case ProductActionTypes.LOAD_SUCCESS_NEXT_PAGE: 
      return {
        ...state,
        products: state.products.concat(action.payload.data),
        loading: false,
        error: false,
      }
    case ProductActionTypes.LOAD_FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case ProductActionTypes.SEARCH_REQUEST:
      return {
        ...state,
        error: false,
        loadingSearch: true,
      };
    case ProductActionTypes.SEARCH_PRODUCT:
      return {
        ...state,
        error: false,
        loadingProduct: true,
      };
    case ProductActionTypes.SEARCH_PRODUCT_SUCCESS:
      return {
        ...state,
        product: action.payload.data,
        loadingProduct: false,
        error: false,
      };
    case ProductActionTypes.SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        search: action.payload.data,
        loadingSearch: false,
        error: false,
      };

    case ProductActionTypes.DETAILS:
      return {
        ...state,
        productDetalails: action.payload.data,
        search: [action.payload.data],
        error: false,
      };

    case ProductActionTypes.CLEAR_PRODUCTS:
      return {
        ...state,
        products: [],
        search: [],
      }
    case ProductActionTypes.SET_FILTERS:
      //konsole.log('ProductActionTypes.SET_FILTERS:', action.payload);
      if ((action.payload.filters.categoryId &&
        action.payload.filters.categoryId !== state.filters.categoryId) ||
        action.payload.filters.categoryId === ''
      ) {
        return {
          ...state,
          response: {
            ...state.response,
            currentPage: 1,
            lastPage: 1,
          },
          filters: {
            ...state.filters,
            ...action.payload.filters,
            page: 1,
          },
          products: []
        }
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload.filters
        },
        response: {
          ...state.response,
          ...action.payload.response,
        }
      };
    default:
      return state;
  }
}
